export const config = {
    "name": "融媒号统计",
    "key": "meltedmedianumberStatistics",
    "nav": [
        {
            "name": "单位",
            "tabKey": "0",
            "request": {
                "url": "/cm-sites-mmp/statistics/mediaFusionNumberTj",
                "method": "get",
                "params": {
                    _id: "",
                    name: "",
                    title: "",
                    startTime: 0,
                    endTime: 0,
                    count: 10,
                    offsite: 1,
                    rmName:"",
                    sortfield :"",
                    sort: 0,
                },
                paramsConfig: {
                    size: "count",
                    page: "offsite",
                    sort: {
                        field: "sortfield",
                        order: {
                            key: "sort",
                            select: {"ascend": '1', "descend": '-1'}
                        },
                    },
                },
                
                resConfig: {
                    count: "count",
                    data: "data"
                },
                "defaultParams": {
                    _id: "",
                    name: "",
                    title: "",
                    startTime: 0,
                    endTime: 0,
                    count: 10,
                    offsite: 1,
                    rmName:"",
                    sortfield :"viewCount",
                    sortType: 0,
                },
            },
            "renderSearch": {
                "searchConfig": [
                    [ 
                        {
                            "style": {
                                "float": "left"
                            },
                            "component": {
                                "name": "sta_Input",
                                "config": {
                                    style: {
                                        width: 224
                                    }
                                }
                            },
                            "placeholder": "请输入融媒体号",
                            "disabled": false,
                            "id": "sta_name",
                            "size": "default",
                            "labelCode": "rmName",
                            "labelName": "请输入融媒体号",
                            "defaultValue": "",
                            "regStr": "",
                            "regMsg": ""
                        },
                        
                        {
                            "style": {
                                "float": "left"
                            },
                            "component": {
                                "name": "sta_Button",
                                "config": {
                                    btnName: "查询",
                                    type: "primary",
                                    clickCall: "onSearch",
                                    style: {
                                        width: 64
                                    }
                                }
                            },
                            "disabled": false,
                            "id": "sta_searchBtn",
                            "size": "default",
                            "labelCode": "",
                        },
                        {
                            "style": {
                                "float": "left"
                            },
                            "component": {
                                "name": "sta_Button",
                                "config": {
                                    btnName: "重置",
                                    type: "default",
                                    clickCall: "onReset",
                                    noRestKey: ["startTime", "endTime"],
                                    style: {
                                        width: 64
                                    }
                                }
                            },
                            "disabled": false,
                            "id": "sta_searchBtn",
                            "size": "default",
                            "labelCode": "",
                        },
                    ],
                    [
                        {
                            "style": {
                                "float": "left"
                            },
                            "component": {
                                "name": "sta_Button",
                                "config": {
                                    btnName: "导出",
                                    type: "default",
                                    clickCall: "onExport",
                                    "request": {
                                        "url": "/cm-sites-mmp/statistics/mediaFusionNumberTjExport",
                                        "method": "downloadGet",
                                        "params": {
                                               pageSize: 9999
                                        },
                                    },
                                    style: {
                                        width: 64
                                    }
                                }
                            },
                            "disabled": false,
                            "id": "sta_searchBtn",
                            "size": "default",
                            "labelCode": "",
                        },
                        {
                            "style": {
                                "float": "right",
                                marginLeft: 'auto'
                            },
                            "component": {
                                "name": "sta_Date",
                                "config": {
                                    selectDateConfig: {
                                        defaultKey: "thisMonth",
                                        selectConfig: ["thisWeek", "lastWeek", "thisMonth", "lastMonth"]
                                    },
                                    onChangeCallFun: "onSearch",
                                    style: {
                                        width: 768
                                    }
                                }
                            },
                            "value:": "this.state.params.name",
                            "placeholder": "自定义日期范围",
                            "disabled": false,
                            "id": "sta_name",
                            'sameDay':true,
                            "size": "default",
                            "labelCode": ["startTime", "endTime"],
                            "defaultValue": [null, null],
                            "labelName": "",
                            "regStr": "",
                            "regMsg": ""
                        },
                    ]
                ]
            },
            "renderTable": {
                "defaultItemWidth": 200,
                "columns": [
                    {
                        "title": '融媒体号',
                        "width": 100,
                        "dataIndex": 'name',
                        "key": 'name',
                    },                    
                    {
                        title: '文章总数',
                        dataIndex: 'articleCount',
                        ellipsis: true,
                        sorter: true,
                        "width": 100,
                    },
                    {
                        title: '视频总数',
                        dataIndex: 'videoCount',
                        ellipsis: true,
                        sorter: true,
                        "width": 100,
                    },
                    {
                        title: '图集总数',
                        dataIndex: 'pictuerCount',
                        ellipsis: true,
                        sorter: true,
                        "width": 100,

                    },
                    {
                        title: '音频总数',
                        dataIndex: 'audioCount',
                        ellipsis: true,
                        sorter: true,
                        "width": 100,
                    },
                    {
                        title: '阅读总数',
                        dataIndex: 'browseCount',
                        ellipsis: true,
                        sorter: true,
                        "width": 100,
                    },
                    {
                        title: '点赞总数',
                        dataIndex: 'thumbsupCount',
                        ellipsis: true,
                        sorter: true,
                        "width": 100,

                    },
                    {
                        title: '分享总数',
                        dataIndex: 'retransmissionCount',
                        ellipsis: true,
                        sorter: true,
                        "width": 100,
                    },
                ]
            },
            "renderPage": {
                size: "middle",
                pageSizeOptions: ['10', '20', '30', '40']
            }
        },
    ]
};
